// @flow

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const VideoLink: MarkdocTagRegistration = {
  tag: 'video-link',
  component: 'VideoLink',
  description: 'Render a video link with the video icon tag',
  children: ['strong', 'em', 'code', 'text', 'tag'],
  attributes: {
    href: {type: String, required: true},
    title: {type: String, localizable: true},
  },
};
